import { useEffect, useState } from "react";
import { useGetCoursesByFacultyQuery } from "@axio/graphql/generated/graphql";
import SearchListModal from "../../../components/common/SearchListModal/SearchListModal";
import { useAppConfig } from "../../../AppConfigProvider";
import Delete from "../../../components/svgs/common/Delete";

const RemoveCourseFromFacultyListContainer = ({
  visible,
  onClose,
  onAction,
  userId,
}: {
  visible: boolean;
  onClose: () => void;
  onAction: (id: string) => void;
  userId: string;
}) => {
  const [searchQuery, setSearchQuery] = useState("");

  const appConfig = useAppConfig();
  const schoolId = appConfig.axioSchools[0];

  const { data: coursesData, refetch: coursesRefetch } = useGetCoursesByFacultyQuery({
    variables: {
      schoolId,
      userId: userId,
      searchQuery,
    },
  });

  useEffect(() => {
    coursesRefetch();
  }, [searchQuery, userId]);

  return (
    <SearchListModal
      visible={visible}
      onClose={onClose}
      onAction={onAction}
      list={
        coursesData?.getCoursesByFaculty?.data.map((course) => ({
          id: course.id,
          name: course.name,
        })) || []
      }
      searchQuery={searchQuery}
      setSearchQuery={setSearchQuery}
      title={"Remove Course"}
      actionLabel="Remove"
      actionIcon={<Delete color="#3E68FE" />}
    />
  );
};

export default RemoveCourseFromFacultyListContainer;
